export default __webpack_public_path__ + "static/media/tertiary-ed-gif.7fd8384d.gif";